export const STATE_DEFAULT = 'default'
export const STATE_ERROR = 'error'
export const STATE_SUCCESS = 'success'
